/* eslint-disable no-unused-vars */
import { apolloClient } from '@/setup/apollo-setup'

import {
  GET_LAWYER,
  GET_LAWYERS,
  GET_LAWYER_OPTIONS,
  CREATE_LAWYER,
  UPDATE_LAWYER,
  DELETE_LAWYER,

  GET_PROSECUTION,
  GET_PROSECUTION_USER_JOB,
  GET_PROSECUTION_LAWYER_JOB,
  GET_PROSECUTIONS,
  GET_PROSECUTIONS_USER_JOB,
  GET_PROSECUTIONS_LAWYER_JOB,
  GET_PROSECUTIONS_CLOSE_CANCEL_HOLD,
  CREATE_PROSECUTION,
  UPDATE_PROSECUTION_USER_JOB,
  UPDATE_PROSECUTION_LAWYER_JOB,
  UPDATE_PROSECUTION_CASE_STATUS,
  DELETE_PROSECUTION,

  GET_PROSECUTION_DETAIL,
  GET_PROSECUTION_DETAILS,
  CREATE_PROSECUTION_DETAIL,
  UPDATE_PROSECUTION_DETAIL,
  DELETE_PROSECUTION_DETAIL,

  CREATE_FILE,
  DELETE_FILE,
  GET_FILE,
  GET_FILES,
  UPDATE_FILE
} from '@/queries/modules/prosecution'

import {
    error,
    addItemSuccess,
    updateItemSuccess,
    deleteItemSuccess,
} from '@/utils/notification'
import axios from "axios";
import {config} from "@/utils/upload";
import {isLawyer as fncIsLawyer} from "@/utils";

export async function getLawyer(context, payload) {
  // console.log('Get Lawyer...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_LAWYER,
        variables,
        fetchPolicy: 'network-only'
      });

    const {data} = await response;
    const {getLawyer} = data;
    context.commit('setLawyer', getLawyer);
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getLawyers(context) {
  // console.log('Get Lawyers...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const response = await apolloClient
      .query({
        query: GET_LAWYERS,
        fetchPolicy: 'network-only'
      });

    const {data} = await response;
    const {getLawyers} = data;
    context.commit('setLawyers', getLawyers);
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getLawyerOptions(context) {
  // console.log('Get Lawyer Options...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const response = await apolloClient
      .query({
        query: GET_LAWYER_OPTIONS,
        fetchPolicy: 'network-only'
      });

    const {data} = await response;
    const {getLawyers: lawyerOptions } = data;

    context.commit('setLawyerOptions', lawyerOptions);
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createLawyer(context, payload) {
  // console.log('Add Lawyer...');

  context.commit('clearError');
  context.commit('setProcessing', true);

  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_LAWYER,
        variables,
        fetchPolicy: 'no-cache'
      });

    context.commit('setSuccess', addItemSuccess({}));
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect);
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null));
  }
}

export async function updateLawyer(context, payload) {
  // console.log('Update Lawyer...');

  context.commit('clearError');
  context.commit('setProcessing', true);

  const variables = {
    id: payload.id,
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_LAWYER,
        variables,
        fetchPolicy: 'no-cache'
      });

    context.commit('setSuccess', updateItemSuccess({}));
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect);
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null));
  }
}

export async function deleteLawyer(context, payload) {
  // console.log('Delete Lawyer...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_LAWYER,
        variables,
        fetchPolicy: 'no-cache'
      });

    const {data} = await response;
    const {deleteLawyer} = data;

    context.commit('delLawyer', deleteLawyer);
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null));
  }
}

export async function setProsecutionFilters(context, payload) {
  context.commit('clearError');
  context.commit('setProcessing', true);

  try {
    context.commit('setSuccess', null);
    context.commit('setProsecutionFilters', payload);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getProsecution(context, payload) {
  // console.log('Get Prosecution...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_PROSECUTION,
        variables,
        fetchPolicy: 'network-only'
      });

    const { data } = await response;
    const { getProsecution: prosecution } = data;

    // console.log("action getProsecution => ", prosecution);

    context.commit('setProsecution', prosecution);
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getProsecutionUserJob(context, payload) {
  // console.log('Get Prosecution...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_PROSECUTION_USER_JOB,
        variables,
        fetchPolicy: 'network-only'
      });

    const { data } = await response;
    const { getProsecution: prosecution } = data;

    context.commit('setProsecution', prosecution);
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getProsecutionLawyerJob(context, payload) {
  // console.log('Get Prosecution...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_PROSECUTION_LAWYER_JOB,
        variables,
        fetchPolicy: 'network-only'
      });

    const { data } = await response;
    const { getProsecution: prosecution } = data;

    context.commit('setProsecution', prosecution);
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getProsecutions(context) {
  // console.log('Get Prosecutions...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const response = await apolloClient
      .query({
        query: GET_PROSECUTIONS,
        fetchPolicy: 'network-only'
      });

    const { data } = await response;
    const { getProsecutions: prosecutions } = data;
    context.commit('setProsecutions', prosecutions);
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getProsecutionsUserJob(context) {
  // console.log('Get Prosecutions...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const response = await apolloClient
      .query({
        query: GET_PROSECUTIONS_USER_JOB,
        fetchPolicy: 'network-only'
      });

    const { data } = await response;
    const { getProsecutionsUserJob: prosecutions } = data;
    context.commit('setProsecutions', prosecutions);
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getProsecutionsLawyerJob(context, payload) {
  // console.log('Get Prosecutions...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const variables = {
      isLawyer: fncIsLawyer(),
    }
    const response = await apolloClient
      .query({
        query: GET_PROSECUTIONS_LAWYER_JOB,
        variables,
        fetchPolicy: 'network-only'
      });

    const { data } = await response;
    const { getProsecutionsLawyerJob: prosecutions } = data;
    context.commit('setProsecutionsByAction', {prosecutions, action: payload.action});
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getProsecutionsCloseCancelHold(context , payload) {
  // console.log('Get Prosecutions...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const variables = {
      isLawyer: fncIsLawyer(),
    }
    const response = await apolloClient
      .query({
        query: GET_PROSECUTIONS_CLOSE_CANCEL_HOLD,
        variables,
        fetchPolicy: 'network-only'
      });

    const { data } = await response;
    const { getProsecutionsCloseCancelHold: prosecutions } = data;
    context.commit('setProsecutionsByAction', {prosecutions, action: payload.action});
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createProsecution(context, payload) {
  // console.log('Add Prosecution...');

  context.commit('clearError');
  context.commit('setProcessing', true);

  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_PROSECUTION,
        variables,
        fetchPolicy: 'no-cache'
      });

    context.commit('setSuccess', addItemSuccess({}));
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect);
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null));
  }
}

export async function updateProsecutionUserJob(context, payload) {
  // console.log('Update Prosecution...');

  context.commit('clearError');
  context.commit('setProcessing', true);

  const variables = {
    id: payload.id,
    payload: payload.form
  }
  // console.log(variables)
  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_PROSECUTION_USER_JOB,
        variables,
        fetchPolicy: 'no-cache'
      });

    context.commit('setSuccess', updateItemSuccess({}));
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect);
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null));
  }
}

export async function updateProsecutionLawyerJob(context, payload) {
  // console.log('Update Prosecution By Lawyer...');

  context.commit('clearError');
  context.commit('setProcessing', true);

  const variables = {
    id: payload.id,
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_PROSECUTION_LAWYER_JOB,
        variables,
        fetchPolicy: 'no-cache'
      });

    context.commit('setSuccess', updateItemSuccess({}));
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect);
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null));
  }
}

export async function updateProsecutionCaseStatus(context, payload) {
  // console.log('Update Prosecution Case Status...');

  context.commit('clearError');
  context.commit('setProcessing', true);

  const variables = {
    id: payload.id,
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_PROSECUTION_CASE_STATUS,
        variables,
        fetchPolicy: 'no-cache'
      });

    context.commit('setSuccess', updateItemSuccess({}));
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null));
  }
}

export async function deleteProsecution(context, payload) {
  // console.log('Delete Prosecution...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_PROSECUTION,
        variables,
        fetchPolicy: 'no-cache'
      });

    const {data} = await response;
    const {deleteProsecution} = data;

    context.commit('delProsecution', deleteProsecution);
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null));
  }
}

export async function getProsecutionDetail(context, payload) {
  // console.log('Get ProsecutionDetail...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_PROSECUTION_DETAIL,
        variables,
        fetchPolicy: 'network-only'
      });

    const { data } = await response;
    const { getProsecutionDetail } = data;
    context.commit('setProsecutionDetail', getProsecutionDetail);
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getProsecutionDetails(context) {
  // console.log('Get ProsecutionDetails...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const response = await apolloClient
      .query({
        query: GET_PROSECUTION_DETAILS,
        fetchPolicy: 'network-only'
      });

    const { data } = await response;
    const { getProsecutionDetails } = data;
    context.commit('setProsecutionDetails', getProsecutionDetails);
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createProsecutionDetail(context, payload) {
  // console.log('Add ProsecutionDetail...');

  context.commit('clearError');
  context.commit('setProcessing', true);

  const variables = {
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_PROSECUTION_DETAIL,
        variables,
        fetchPolicy: 'no-cache'
      });

    const { data } = await response;
    const { createProsecutionDetail: prosecutionDetail } = data;

    context.commit('setSuccess', addItemSuccess({}));
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null));
  }
}

export async function updateProsecutionDetail(context, payload) {
  // console.log('Update ProsecutionDetail...');

  context.commit('clearError');
  context.commit('setProcessing', true);

  const variables = {
    id: payload.id,
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_PROSECUTION_DETAIL,
        variables,
        fetchPolicy: 'no-cache'
      });

    context.commit('setSuccess', updateItemSuccess({}));
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null));
  }
}

export async function deleteProsecutionDetail(context, payload) {
  // console.log('Delete ProsecutionDetail...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const variables = {
      id: payload.form.id
    }

    // console.log(variables)

    const response = await apolloClient
      .mutate({
        mutation: DELETE_PROSECUTION_DETAIL,
        variables,
        fetchPolicy: 'no-cache'
      });

    const {data} = await response;
    const {deleteProsecutionDetail} = data;

    context.commit('delProsecutionDetail', deleteProsecutionDetail);
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null));
  }
}

// export async function getProsecutionDetailFiles(context, payload) {
//   // console.log('Get ProsecutionDetail Files...')
//
//   context.commit('clearError')
//   context.commit('setProcessing', true)
//
//   const variables = { id: payload.form.id }
//   try {
//     const response = await apolloClient
//       .query({
//         query: GET_CONTRACT_FILES,
//         variables,
//         fetchPolicy: 'network-only'
//       })
//     const {data} = await response
//     context.commit('setContractFiles', data.getContract)
//     context.commit('setSuccess', null)
//   } catch (e) {
//     // console.log(e);
//     context.commit('setError', error(e.toString(), null));
//   }
// }

export async function uploadFile(context, payload) {
  // console.log('Create Receipts...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  try {
    const result = await axios({
      url: config.url.uploads,
      method: 'post',
      headers: {
        'content-type': 'multipart/form-data'
      },
      data: payload.form.formData,
    });

    const {data} = await result;

    return data;
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}

export async function getFile(context, payload) {
  // console.log('Get File...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_FILE,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setFile', data.getFile)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getFiles(context) {
  // console.log('Get Files...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_FILES,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setFiles', data.getFiles)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createFile(context, payload) {
  // console.log('Add File...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_FILE,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response
    const { createFile: file } = data;
    // context.commit('addFiles', file)
    context.commit('setSuccess', addItemSuccess({}))
    return file;
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}

export async function updateFile(context, payload) {
  // console.log('Update File...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }

  try {
    await apolloClient
      .mutate({
        mutation: UPDATE_FILE,
        variables,
        fetchPolicy: 'no-cache'
      })
    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}

export async function deleteFile(context, payload) {
  // console.log('Delete File...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  const variables = {
    id: payload.form.id
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: DELETE_FILE,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response

    context.commit('delFile', data.deleteFile)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null))
  }
}
